import type { ChangeEvent } from 'react';
import React from 'react';

import Input from './index';
import type { InputProps } from './types';

interface InputWithReplaceProps extends InputProps {
  replace?: (value: string) => string;
}

interface InputWithFormatProps extends InputProps {
  format: (value: string) => string;
  unformat: (value: string) => string;
}

export const InputWithReplace = (props: InputWithReplaceProps) => {
  const { replace, onChange, ...restProps } = props;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let updatedEvent = event;

    if (typeof replace === 'function') {
      const replacedValue = replace(event.target.value);

      updatedEvent = {
        ...event,
        target: {
          ...event.target,
          value: replacedValue,
        },
      };
    }

    onChange(updatedEvent);
  };

  return <Input {...restProps} onChange={handleChange} />;
};

export const InputWithFormat = (props: InputWithFormatProps) => {
  const { format, unformat, value, onChange, ...restProps } = props;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let updatedEvent = event;

    const unformattedValue = unformat(event.target.value);

    updatedEvent = {
      ...event,
      target: {
        ...event.target,
        value: unformattedValue,
      },
    };

    onChange(updatedEvent);
  };

  return <Input {...restProps} value={format(value)} onChange={handleChange} />;
};

export const InputWithTrim = (props: InputProps) => {
  const { onChange, onBlur, ...restProps } = props;

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const trimmedValue = event.target.value.trim();
    onChange({
      ...event,
      target: { ...event.target, value: trimmedValue },
    });
    onBlur(event);
  };

  return <Input {...restProps} onChange={onChange} onBlur={handleBlur} />;
};
